import React, { Dispatch, SetStateAction } from "react"
import { CapabilityProvider } from "lib/types/generated/graphql-types"

import { Url } from "./ExternalPriceConfig.styled"
import { Container, EmptyList, Wrapper } from "components/Ui/Table/Shared.styled"

import ErrorMessage from "components/Ui/Messages/ErrorMessage"
import TableBlurLoading from "components/Ui/Table/TableBlurLoading"
import { ExternalPriceConfigTableRow, getLoadingRow } from "./ExternalPriceConfigTableRow"

import { ReactComponent as ExternalPriceLogo } from "images/icons/circle-dollar.svg"
import TableHeader from "../../Ui/Table/TableHeader"

type Props = {
  externalPriceConfigurations: CapabilityProvider[]
  error: object | undefined
  setExternalPriceConfigId?: Dispatch<SetStateAction<string>>
  loading: boolean
}

const tableHeader = (
  <TableHeader iconHeader={true}>
    <div>Identifier</div>
    <Url className="hideOnSmallScreens">Base URL</Url>
    <Url className="hideOnSmallScreens">Auth URL</Url>
    <div className="hideOnSmallScreens">Created</div>
    <div className="hideOnSmallScreens">Updated</div>
  </TableHeader>
)

export const ExternalPriceConfigTable = ({
  externalPriceConfigurations,
  setExternalPriceConfigId,
  error,
  loading
}: Props) => {
  if (loading)
    return <TableBlurLoading numberOfRows={2} tableHeader={tableHeader} rows={getLoadingRow()} />

  if (externalPriceConfigurations?.length < 1)
    return (
      <EmptyList>
        <ExternalPriceLogo /> <p> No configurations added</p>
      </EmptyList>
    )

  return (
    <Wrapper>
      <Container>
        {error && (
          <ErrorMessage
            showRefreshButton
            message={
              <>
                Error loading External Price provider settings. Try refreshing the page, or contact{" "}
                <a href="mailto:support@brinkcommerce.com">support</a>.
              </>
            }
          />
        )}
        {tableHeader}
        {[...externalPriceConfigurations].map((externalPriceProvider) => (
          <ExternalPriceConfigTableRow
            key={externalPriceProvider.id}
            id={externalPriceProvider.id}
            setExternalPriceConfigId={setExternalPriceConfigId}
          />
        ))}
      </Container>
    </Wrapper>
  )
}
